import * as Select from '@radix-ui/react-select';
import { type VariantProps, cva } from 'class-variance-authority';
import { forwardRef } from 'react';
import { Icon } from '../../Icon/Icon';

const dropdownItem = cva(
  'bg-surface-strong rounded-xs hover:bg-primary hover:text-content-inverse p-xs hover:cursor-pointer items-center outline-none flex p-xs gap-x-xs',
);

type DropdownItemProps = VariantProps<typeof dropdownItem> & {
  value: string;
  text: string;
  disabled?: boolean;
  /** Overrides the accessible name; defaults to `text` when omitted. */
  ariaLabel?: string;
};

/**
 * To be used within a Dropdown or DropdownGroup component.
 *
 * @components
 * ItemText ==> Visual text part of the item. Should not be styled to ensure correct positioning.
 * ItemIndicator ==> Renders when the item is selected.
 */
// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
const DropdownItem = forwardRef<HTMLDivElement, DropdownItemProps>(
  ({ text, ariaLabel, ...props }, forwardedRef) => (
    <Select.Item
      ref={forwardedRef}
      className={dropdownItem()}
      aria-label={ariaLabel ?? text}
      {...props}
    >
      <div className="flex items-center justify-center">
        <Select.ItemIndicator className="inline-flex align-middle">
          <Icon name="check" size="small" />
        </Select.ItemIndicator>
      </div>
      <Select.ItemText>{text}</Select.ItemText>
    </Select.Item>
  ),
);
DropdownItem.displayName = 'DropdownItem';

export { DropdownItem };
